import { Briefcase, Layout, Server, TrendingUp } from 'lucide-react';
import ListDetail from 'pages/listDetail';
import CompanyJobBoard from 'pages/CompanyJobBoard';
import { ContactsExtended } from '../pages/contactsExtended';
import { ContactsAddSingleContact } from '../pages/contactsAddSingleContact';
import { ContactsEditSingleContact } from '../pages/contactsEditSingleContact';
import { ContactsImportSuccess } from '../pages/contactsImportSuccess';
import { ContactsImportCsv } from '../pages/contactsImportCsv';
import { ContactsLinkedInSync } from '../pages/contactsLinkedInSync';
import { Hires } from '../pages/hires';
import { Movements } from '../pages/movements';
import Analytics from '../pages/Analytics';
import CompanyProfile from '../pages/CompanyProfile';
import Employers from '../pages/Employers';
import Job from '../pages/Job';
import NetworkHome from '../pages/NetworkHome';
import addCompanyRoutes from './addCompanyRoutes';
import Jobs from '../pages/Jobs';
import RenewJob from '../pages/RenewJob';
import PostJob from '../pages/PostJob';
import CompanyAdmins from '../pages/CompanyAdmins';
import CompanyJobs from '../pages/CompanyJobs';
import Impact from '../pages/dashboard';
import List from '../pages/list';
import { SettingsPage } from '../pages/Settings';
import JobBoardAppearance from '../pages/Settings/jobBoardAppearance';
import Playbook from '../pages/playbook';
import CompanyAts from '../pages/CompanyAts';
import { sourcingAgentRoutes } from '../pages/sourcingAgent';
import { Projects } from '../pages/projects';
import { Campaigns } from '../pages/campaigns';
import { TalentCommunities } from '../pages/talentCommunities';
import { CompanyResearch } from '../pages/companyResearch';
import { JobBoardIntro } from '../pages/jobBoardIntro';
import { FindCandidates } from '../pages/findCandidates';

export const networkRoutes = {
  addCompany: addCompanyRoutes,
  analytics: {
    path: '/analytics',
    component: Analytics,
    name: 'Analytics',
    icon: TrendingUp,
  },
  companyProfile: {
    path: ['/companies/:companySlug', '/company-profile/:companySlug'],
    component: CompanyProfile,
    name: 'Company profile',
    icon: Layout,
    exact: true,
  },
  companyAdmins: {
    path: ['/companies/:companySlug/admins', '/company-profile/:companySlug/admins'],
    component: CompanyAdmins,
    name: 'Company admins',
    icon: Layout,
    exact: true,
  },
  companyJobBoard: {
    path: ['/companies/:companySlug/job-boards', '/company-profile/:companySlug/job-boards'],
    component: CompanyJobBoard,
    name: 'Company job board',
    icon: Layout,
    exact: true,
  },
  companyJobs: {
    path: ['/companies/:companySlug/jobs', '/company-profile/:companySlug/jobs'],
    component: CompanyJobs,
    name: 'Company jobs',
    icon: Layout,
    exact: true,
  },
  companyAts: {
    path: ['/companies/:companySlug/ats', '/company-profile/:companySlug/ats'],
    component: CompanyAts,
    name: 'Company ATS',
    icon: Layout,
    exact: true,
  },
  list: {
    path: '/lists',
    component: List,
    name: 'lists',
  },
  listDetail: {
    path: '/list/:listId',
    component: ListDetail,
    name: 'listsDetail',
  },
  contacts: {
    path: '/contacts',
    component: ContactsExtended,
    name: 'contacts',
  },
  contactsAddSingleContact: {
    path: '/contact/add',
    component: ContactsAddSingleContact,
    name: 'Add single contact',
    exact: true,
  },
  contactsEditSingleContact: {
    path: '/contact/:contactId/edit',
    component: ContactsEditSingleContact,
    name: 'Edit contact',
    exact: true,
  },
  contactsImportSuccess: {
    path: '/import-contacts/success',
    component: ContactsImportSuccess,
    name: 'Import contacts success',
    exact: true,
  },
  contactsImportCsv: {
    path: '/import-contacts/csv',
    component: ContactsImportCsv,
    name: 'Import contacts',
    exact: true,
  },
  contactsLinkedInSync: {
    path: '/linkedin/:action',
    component: ContactsLinkedInSync,
    name: 'LinkedIn sync',
    exact: true,
  },
  hires: {
    path: ['/hires', '/hires/:contactId'],
    component: Hires,
    name: 'Hires',
    visibility: ['job_board'],
  },
  movements: {
    path: '/movements',
    component: Movements,
    name: 'Movements',
  },
  editJob: {
    path: '/companies/:companyId/:action/:jobId',
    component: Job,
    name: 'Edit job',
    exact: true,
    visibility: ['job_board'],
  },
  employers: {
    path: '/companies',
    component: Employers,
    name: 'Companies',
    icon: Briefcase,
    exact: true,
    visibility: ['job_board'],
  },
  jobs: {
    path: '/jobs',
    component: Jobs,
    name: 'Jobs',
    icon: Server,
    exact: true,
    visibility: ['job_board'],
  },
  networkPostJob: {
    path: '/jobs/post-job',
    component: PostJob,
    name: 'Post a job',
    exact: true,
    visibility: ['job_board'],
  },
  renewJob: {
    path: '/jobs/:jobId/renew',
    component: RenewJob,
    name: 'Renew job',
    exact: true,
    visibility: ['job_board'],
  },
  networkEditJob: {
    path: '/jobs/:action/:jobId',
    component: PostJob,
    name: 'Edit job',
    exact: true,
    visibility: ['job_board'],
  },
  postJob: {
    path: ['/companies/:companyId/post-job', '/company-profile/:companyId/post-job'],
    component: Job,
    name: 'Post job',
    exact: true,
    visibility: ['job_board'],
  },
  networkHome: {
    path: '/',
    component: NetworkHome,
    name: 'NetworkHome',
    exact: true,
  },
  settings: {
    path: '/settings/',
    component: SettingsPage,
    name: 'Settings',
  },
  jobBoardLivePreview: {
    path: '/job-board/live-preview',
    component: JobBoardAppearance,
    name: 'Job board live preview',
    exact: true,
    visibility: ['job_board'],
  },
  jobBoardDashboard: {
    path: '/dashboard',
    component: Impact,
    name: 'Home',
    visibility: ['job_board'],
  },
  home: {
    path: '/home',
    component: Playbook,
    name: 'Playbook',
    exact: true,
  },
  projects: {
    path: '/projects',
    component: Projects,
    name: 'Projects',
  },
  campaigns: {
    path: '/campaigns',
    component: Campaigns,
    name: 'Nurture Campaigns',
  },
  talentCommunities: {
    path: '/talent-communities',
    component: TalentCommunities,
    name: 'Talent Communities',
  },
  companyResearch: {
    path: '/company-research',
    component: CompanyResearch,
    name: 'Company Research',
  },
  jobBoardIntro: {
    path: '/job-board-intro',
    component: JobBoardIntro,
    name: 'Job Board',
    exact: true,
  },
  findCandidates: {
    path: '/find-candidates',
    component: FindCandidates,
    name: 'Find Candidates',
    exact: true,
  },
  ...sourcingAgentRoutes,
};
